export const REQUIRED_FIELD = "Field is required";
export const GREATER_THAN_0 = "Value must be ≥ 0";
export const INVALID_NUMBER = "Invalid number";
export const INTEGER_VALUE = "Decimals not allowed";
export const INVALID_DATE = "Invalid date";
